import Vue from 'vue'
import partical from 'vue-particles'

Vue.use(partical)